<script setup>
import {reactive, provide} from "vue";
import SideBarUpdates from "@/views/trackers/tracker/SideBarUpdates.vue";

const filters = reactive({
    'added-startups': true,
    'removed-startups': true,
    'added-ecosystems': true,
    'removed-ecosystems': true,
    'reviews': true,
    'changed-stage': true,
    'changed-poc-status': true,
    'tasks': true,
    'notes': true,
    'insights': true
});

const trackerUpdatesFilters = [
    'notes',
    'added-startups',
    'removed-startups',
    'added-ecosystems',
    'removed-ecosystems',
    'tasks',
    'reviews',
    'changed-stage',
    'changed-poc-status',
];

provide('filters', filters);
provide('trackerUpdatesFilters', trackerUpdatesFilters);
</script>

<template>
    <SideBarUpdates/>
</template>

<style scoped>

</style>
